<template>
    <module-card :nextDisabled="nextDisabled">
        <p>
            In this activity you should correctly order the steps for using a condom. In order to re-order the steps, click on the step you want to move, then click on the space you would like to move it to. Once an item is
            <span class="success--text font-weight-bold">green</span>, it is in the correct order.
        </p>
        <transition-group name="sort-list" tag="div">
            <v-row
                align="center"
                v-for="(step, index) in shuffledStepsOrder"
                :key="step.order"
                class="grey lighten-3 px-2 ml-3 mb-1"
                :class="{ success: isCorrect(step.order, index), info: index === selectedIndex, available: isAvailable(step.order, index) }"
                @click="click(step.order, index)"
            >
                <v-col cols="1" class="ordinal" :class="{ 'info--text': isAvailable(step.order, index) }">
                    <div>{{ index + 1 }}</div>
                </v-col>
                <v-col cols="1">
                    <v-icon v-if="isCorrect(step.order, index)">mdi-check</v-icon>
                    <v-icon v-else>mdi-minus</v-icon>
                </v-col>
                <v-col>{{ step.step }}</v-col>
            </v-row>
        </transition-group>
    </module-card>
</template>

<script>
    import { shuffle, every } from 'lodash';

    export default {
        data() {
            return {
                steps: [
                    {
                        order: 1,
                        step: 'Check the expiration date on the wrapper'
                    },
                    {
                        order: 2,
                        step: 'Open the package without tearing the condom'
                    },
                    {
                        order: 3,
                        step: 'Squeeze a few drops of water-based lube into the tip of the condom'
                    },
                    {
                        order: 4,
                        step: 'Hold the condom by the last ½ inch at the tip, squeeze out any air'
                    },
                    {
                        order: 5,
                        step: 'Start to put the condom on when the dick is hard and before the dick touches the partner’s genitalia, mouth or ass'
                    },
                    {
                        order: 6,
                        step: 'Put the condom on the tip of the dick'
                    },
                    {
                        order: 7,
                        step: 'While still pinching the tip, unroll the condom down the shaft of the dick'
                    },
                    {
                        order: 8,
                        step: 'Check during sex to make sure the condom isn’t slipping off'
                    },
                    {
                        order: 9,
                        step: 'After cumming, pull out while holding the condom by its rim (at the base of the dick, near the balls)'
                    },
                    {
                        order: 10,
                        step: 'Remove the condom while holding it by the base or rim (and away from the partner’s body)'
                    },
                    {
                        order: 11,
                        step: 'Throw the condom away (not in a toilet!)'
                    },
                    {
                        order: 12,
                        step: 'Never re-use a condom. Use a new one every time you have sex, and repeat these steps.'
                    }
                ],
                selectedIndex: null,
                shuffledStepsOrder: []
            };
        },
        mounted() {
            this.shuffledStepsOrder = shuffle(this.steps);
        },
        methods: {
            isCorrect(key, index) {
                return parseInt(key) === index + 1;
            },
            isAvailable(key, index) {
                return this.selectedIndex !== null && this.selectedIndex !== index && !this.isCorrect(key, index);
            },
            click(key, index) {
                if (this.isCorrect(key, index)) {
                    return;
                }
                if (this.selectedIndex !== null) {
                    const a = this.shuffledStepsOrder[this.selectedIndex];
                    const b = this.shuffledStepsOrder[index];
                    this.shuffledStepsOrder.splice(this.selectedIndex, 1, b);
                    this.shuffledStepsOrder.splice(index, 1, a);

                    this.selectedIndex = null;
                } else {
                    this.selectedIndex = index;
                }
            },
            isShuffledStepsOrderSorted() {
                return every(this.shuffledStepsOrder, (o, index) => {
                    return parseInt(o.order) === index + 1;
                });
            },
            nextDisabled() {
                return !this.isShuffledStepsOrderSorted();
            }
        }
    };
</script>

<style scoped>
    .ordinal {
        margin-left: -3em;
        padding-right: 2em;
        width: 2em;
    }
    .ordinal div {
        font-weight: bold;
        width: 20px;
        margin-left: -2px;
        text-align: center;
    }
    .available {
        box-shadow: 0 0 0 1px inset #0091ff;
        opacity: 0.75;
    }
    .sort-list-move {
        transition: transform 1s;
    }
</style>
